import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { Client } from '@/lib/types';
import { painLevelDisplayLabel } from '@/lib/clients/roster-fields';

const EXPERIENCE_LEVELS = ['Beginner Lifter', 'Novice Lifter', 'Intermediate Lifter', 'Athlete'];

interface ClientMedicalSummaryProps {
  client: Client;
}

export function ClientMedicalSummary({ client }: ClientMedicalSummaryProps) {
  return (
    <Card className="border-none shadow-md" data-testid="client-medical-summary">
      <CardHeader>
        <CardTitle className="text-base">Medical summary</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <h4 className="text-sm font-medium text-muted-foreground mb-1">Lifting experience</h4>
            <p className="text-sm font-semibold">
              {EXPERIENCE_LEVELS[client.liftingExperience ?? 0] ?? '—'}
            </p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-muted-foreground mb-1">Pain level</h4>
            <p className="text-sm font-semibold" data-testid="client-pain-level-display">
              {painLevelDisplayLabel(client)}
            </p>
          </div>
        </div>
        {[
          { label: 'Medical history', value: client.medicalHistory },
          { label: 'Injury history', value: client.injuryHistory },
          { label: 'Goals', value: client.goals },
        ].map((section) => (
          <div key={section.label}>
            <h4 className="text-sm font-medium text-muted-foreground mb-2">{section.label}</h4>
            <div className="p-4 bg-muted/50 rounded-lg text-sm break-words whitespace-pre-wrap">
              {section.value?.trim() || 'Not recorded.'}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
